import { useMemo } from "react";
import CoverImage1 from "../../../../../../assets/image/cover1.jpg";
import CoverImage2 from "../../../../../../assets/image/cover2.jpg";
import CoverImage3 from "../../../../../../assets/image/cover3.jpg";
import CoverImage4 from "../../../../../../assets/image/cover4.jpg";

export const useBackgroundCoverImage = (image: string, shouldShowImage: boolean) => {
    const backgroundCoverImage = useMemo(() => {
        if (shouldShowImage === true) {
            switch (image) {
                case "BACKGROUND_COVER_1":
                    return CoverImage1;
                case "BACKGROUND_COVER_2":
                    return CoverImage2;
                case "BACKGROUND_COVER_3":
                    return CoverImage3;
                case "BACKGROUND_COVER_4":
                    return CoverImage4;
            }
        }
    }, [image, shouldShowImage]);

    return {
        backgroundCoverImage,
    };
};
